import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const FamilyFormSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="family-form-submissions"
    title="טבלת הגשות טופס משפחה"
    emptyLabel="אין הגשות להצגה"
    formPageUrl="https://rafael-car-show.co.il/family-form"
  />
);

export default FamilyFormSubmissionsTable;
